<template>
    <b-row class="mt-4">
        <div class="col-2 d-none d-lg-block"></div>
        <div class="col-12 col-lg-9 ml-3 guide-list">
            <h4 id="overview" class="mt-0">Miscellaneous</h4>

        </div>
    </b-row>
</template>

<script>
    export default {
        name: "Miscellaneous"
    }
</script>
